export enum DisclaimerType {
  FINALIZE_STANDARD_PLAN_REGISTRATION = 'finalize_standard_plan_registration',
  FINALIZE_BASIC_PLAN_REGISTRATION = 'finalize_basic_plan_registration'
}
